(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sf-halloween-product-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sf-halloween-product-offer')) {
    customElements.define('sf-halloween-product-offer', class extends HTMLElement {
      connectedCallback() {
        this.copyButton = this.querySelector('.sf-product-offer__copy');
        this.copyLabel = this.querySelector('[data-copy-label]');
        this.status = this.querySelector('[role="status"]');
        this.copyHandler = async () => {
          if (this.hidden || this.expired()) return;
          try {
            if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
            await navigator.clipboard.writeText(this.dataset.code);
            this.copyLabel.textContent = this.dataset.copied;
            this.status.textContent = this.dataset.success;
          } catch {
            this.status.textContent = this.dataset.failure;
          }
        };
        this.copyButton?.addEventListener('click', this.copyHandler);
        this.expiryTimer = setInterval(() => this.expired(), 30000);
        this.expired();
      }
      expired() {
        const end = Date.parse(this.dataset.expires);
        if (!Number.isFinite(end) || Date.now() >= end) {
          this.hidden = true;
          clearInterval(this.expiryTimer);
          return true;
        }
        return false;
      }
      disconnectedCallback() {
        this.copyButton?.removeEventListener('click', this.copyHandler);
        clearInterval(this.expiryTimer);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
